module.exports = __webpack_public_path__ + "img/punch.8ddb504e.png";